import * as yup from "yup";
import i18next from "config/i18next";
import { accountingDataAR } from "./accountData/AR/schema";
import { accountingDataCO } from "./accountData/CO/schema";
import { accountingDataMX } from "./accountData/MX/schema";
import { vehicleSchemaAR } from "./vehicleData/AR/schema";
import { personalData } from "./personalData/schema";
import { vehicleSchemaCO } from "./vehicleData/CO/schema";
import { vehicleSchemaMX } from "./vehicleData/MX/schema";
import { CountryCodeType } from "reducers/types/session";
import { AccountParams, PickerCountrySchema } from "./types";
import { MOTORIZED_VEHICLES_TAGS, VehicleTagType } from "utils/constants";
import { accountingDataCL } from "./accountData/CL/schema";
import { vehicleSchemaCL } from "./vehicleData/CL/schema";

const requiredMessage = i18next.t("validations:required");

const region = yup.object({
  id: yup.string().required(requiredMessage),
});

const workzone = yup.string().required(requiredMessage).nullable();

const ranking = yup.object({
  fullRanking: yup.boolean(),
});

const countrySchemas: PickerCountrySchema = {
  AR: {
    account: accountingDataAR,
    vehicle: vehicleSchemaAR,
  },
  CO: {
    account: accountingDataCO,
    vehicle: vehicleSchemaCO,
  },
  MX: {
    account: accountingDataMX,
    vehicle: vehicleSchemaMX,
  },
  CL: {
    account: accountingDataCL,
    vehicle: vehicleSchemaCL,
  },
};

export const validationSchema = (
  vehicle: VehicleTagType,
  approve: boolean,
  country: CountryCodeType,
  hasComeFromCode?: boolean,
  hasComeFrom?: boolean,
  invalidBank?: boolean,
  duplicatedFiscalNumber?: boolean
) => {
  const accountParams: AccountParams = {
    AR: { approve, duplicatedFiscalNumber, invalidBank },
    CO: { approve, duplicatedFiscalNumber },
    MX: { approve, duplicatedFiscalNumber },
    CL: { approve, duplicatedFiscalNumber },
  };
  return yup.object({
    region: region,
    desiredWorkzones: workzone,
    ranking: approve ? ranking : yup.object({}),
    personalData: personalData(hasComeFromCode, approve),
    accountingData: countrySchemas[country].account(accountParams[country]),
    vehicle: MOTORIZED_VEHICLES_TAGS.includes(vehicle)
      ? countrySchemas[country].vehicle(approve, vehicle)
      : yup.object({}),
  });
};
